var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _vm.loaded
      ? _c(
          "div",
          { staticClass: "form-container" },
          [
            [
              _c("vue-form", {
                attrs: {
                  structure: JSON.parse(_vm.loginForm.formData),
                  "form-id": _vm.loginForm.id,
                  identifier: _vm.identifier,
                  "base-path": "basePath",
                  "csrf-token": _vm.csrfToken,
                  "success-text": "",
                  "form-class": "webform login",
                  "controller-action": _vm.loginAction,
                  "duplicate-fields": [{ source: "email", target: "username" }],
                  "callback-success": _vm.successLogin,
                },
              }),
              _vm._v(" "),
              _vm.error
                ? _c("div", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.errorText) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "register-info" }, [
                _c("div", { staticClass: "inner" }, [
                  _c("a", { attrs: { href: _vm.registerUrl } }, [
                    _vm._v(_vm._s(_vm.registerText)),
                  ]),
                ]),
              ]),
            ],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }